import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import News from "@/pages/News";
import Events from "@/pages/Events";
import RadioPage from "@/pages/RadioPage";
import About from "@/pages/About";
import CalendarPage from "@/pages/CalendarPage";
import Gallery from "@/pages/Gallery";
import TvSlideshow from "@/pages/TvSlideshow";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isTv = location.pathname.startsWith("/tv");
  if (isTv) return children;
  return (
    <>
      <Navbar />
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/noticias" element={<News />} />
              <Route path="/eventos" element={<Events />} />
              <Route path="/calendario" element={<CalendarPage />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/radio" element={<RadioPage />} />
              <Route path="/nosotros" element={<About />} />
              <Route path="/tv" element={<TvSlideshow />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/panel" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
